import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import '../Components/components.css'

export default class Navbar extends Component {
    render() {
        return (
            <div className="navbar">
                <div className="navbar-list-items">
                    <Link to="/" className="links-in-navbar">Home</Link>
                </div>
                <div className="navbar-list-items">
                    <Link to="/about" className="links-in-navbar">About</Link>
                </div>
                {/* <div className="navbar-list-items">
                    <Link to="/register" className="links-in-navbar">Register</Link>
                </div>
                <div className="navbar-list-items">
                    <Link to="/login" className="links-in-navbar">Login</Link>
                </div> */}
                <div className="navbar-list-items">
                    <Link to="/contact" className="links-in-navbar">Contact</Link>
                </div>
            </div>
        )
    }
}
